"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Version = exports.Collaborator = exports.Rule = exports.FindOptions = exports.Filter = exports.Action = exports.Access = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const struct_1 = require("../google/protobuf/struct");
var Access;
(function (Access) {
    Access[Access["ANY"] = 0] = "ANY";
    Access[Access["MINE"] = 1] = "MINE";
    Access[Access["ROLE"] = 2] = "ROLE";
    Access[Access["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Access || (exports.Access = Access = {}));
var Action;
(function (Action) {
    Action[Action["UNKNOWN"] = 0] = "UNKNOWN";
    Action[Action["CREATE"] = 1] = "CREATE";
    Action[Action["READ"] = 2] = "READ";
    Action[Action["UPDATE"] = 3] = "UPDATE";
    Action[Action["DELETE"] = 4] = "DELETE";
    Action[Action["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Action || (exports.Action = Action = {}));
function createBaseFilter() {
    return { op: "", field: "", value: undefined };
}
exports.Filter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.op !== "") {
            writer.uint32(10).string(message.op);
        }
        if (message.field !== "") {
            writer.uint32(18).string(message.field);
        }
        if (message.value !== undefined) {
            struct_1.Value.encode(struct_1.Value.wrap(message.value), writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.op = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.field = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.value = struct_1.Value.unwrap(struct_1.Value.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Filter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFilter();
        message.op = (_a = object.op) !== null && _a !== void 0 ? _a : "";
        message.field = (_b = object.field) !== null && _b !== void 0 ? _b : "";
        message.value = (_c = object.value) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseFindOptions() {
    return { sort: [], pageNum: 0, pageSize: 0, fields: [], excludeFields: false, offset: 0, limit: 0 };
}
exports.FindOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.sort) {
            writer.uint32(10).string(v);
        }
        if (message.pageNum !== 0) {
            writer.uint32(16).int32(message.pageNum);
        }
        if (message.pageSize !== 0) {
            writer.uint32(24).int32(message.pageSize);
        }
        for (const v of message.fields) {
            writer.uint32(34).string(v);
        }
        if (message.excludeFields === true) {
            writer.uint32(40).bool(message.excludeFields);
        }
        if (message.offset !== 0) {
            writer.uint32(48).int32(message.offset);
        }
        if (message.limit !== 0) {
            writer.uint32(56).int32(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sort.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.pageNum = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.pageSize = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.fields.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.excludeFields = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.offset = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseFindOptions();
        message.sort = ((_a = object.sort) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.pageNum = (_b = object.pageNum) !== null && _b !== void 0 ? _b : 0;
        message.pageSize = (_c = object.pageSize) !== null && _c !== void 0 ? _c : 0;
        message.fields = ((_d = object.fields) === null || _d === void 0 ? void 0 : _d.map((e) => e)) || [];
        message.excludeFields = (_e = object.excludeFields) !== null && _e !== void 0 ? _e : false;
        message.offset = (_f = object.offset) !== null && _f !== void 0 ? _f : 0;
        message.limit = (_g = object.limit) !== null && _g !== void 0 ? _g : 0;
        return message;
    },
};
function createBaseRule() {
    return {
        collectionId: "",
        actions: [],
        access: 0,
        hiddenFields: [],
        readonlyFields: [],
        writeonlyFields: [],
        readFilter: "",
        writeFilter: "",
        denyReadFields: [],
        denyWriteFields: [],
    };
}
exports.Rule = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.collectionId !== "") {
            writer.uint32(10).string(message.collectionId);
        }
        writer.uint32(18).fork();
        for (const v of message.actions) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.access !== 0) {
            writer.uint32(24).int32(message.access);
        }
        for (const v of message.hiddenFields) {
            writer.uint32(42).string(v);
        }
        for (const v of message.readonlyFields) {
            writer.uint32(50).string(v);
        }
        for (const v of message.writeonlyFields) {
            writer.uint32(58).string(v);
        }
        if (message.readFilter !== "") {
            writer.uint32(66).string(message.readFilter);
        }
        if (message.writeFilter !== "") {
            writer.uint32(74).string(message.writeFilter);
        }
        for (const v of message.denyReadFields) {
            writer.uint32(82).string(v);
        }
        for (const v of message.denyWriteFields) {
            writer.uint32(90).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 2:
                    if (tag === 16) {
                        message.actions.push(reader.int32());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.actions.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.access = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.hiddenFields.push(reader.string());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.readonlyFields.push(reader.string());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.writeonlyFields.push(reader.string());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.readFilter = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.writeFilter = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.denyReadFields.push(reader.string());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.denyWriteFields.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Rule.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseRule();
        message.collectionId = (_a = object.collectionId) !== null && _a !== void 0 ? _a : "";
        message.actions = ((_b = object.actions) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        message.access = (_c = object.access) !== null && _c !== void 0 ? _c : 0;
        message.hiddenFields = ((_d = object.hiddenFields) === null || _d === void 0 ? void 0 : _d.map((e) => e)) || [];
        message.readonlyFields = ((_e = object.readonlyFields) === null || _e === void 0 ? void 0 : _e.map((e) => e)) || [];
        message.writeonlyFields = ((_f = object.writeonlyFields) === null || _f === void 0 ? void 0 : _f.map((e) => e)) || [];
        message.readFilter = (_g = object.readFilter) !== null && _g !== void 0 ? _g : "";
        message.writeFilter = (_h = object.writeFilter) !== null && _h !== void 0 ? _h : "";
        message.denyReadFields = ((_j = object.denyReadFields) === null || _j === void 0 ? void 0 : _j.map((e) => e)) || [];
        message.denyWriteFields = ((_k = object.denyWriteFields) === null || _k === void 0 ? void 0 : _k.map((e) => e)) || [];
        return message;
    },
};
function createBaseCollaborator() {
    return { spaceId: "", subject: "", role: "" };
}
exports.Collaborator = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.subject !== "") {
            writer.uint32(18).string(message.subject);
        }
        if (message.role !== "") {
            writer.uint32(26).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCollaborator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subject = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.role = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Collaborator.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCollaborator();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.subject = (_b = object.subject) !== null && _b !== void 0 ? _b : "";
        message.role = (_c = object.role) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseVersion() {
    return { serverVersion: "", apiVersion: "", buildTime: "", commit: "", buildNumber: 0 };
}
exports.Version = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.serverVersion !== "") {
            writer.uint32(10).string(message.serverVersion);
        }
        if (message.apiVersion !== "") {
            writer.uint32(18).string(message.apiVersion);
        }
        if (message.buildTime !== "") {
            writer.uint32(26).string(message.buildTime);
        }
        if (message.commit !== "") {
            writer.uint32(34).string(message.commit);
        }
        if (message.buildNumber !== 0) {
            writer.uint32(40).int32(message.buildNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.serverVersion = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.apiVersion = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.buildTime = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.commit = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.buildNumber = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Version.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseVersion();
        message.serverVersion = (_a = object.serverVersion) !== null && _a !== void 0 ? _a : "";
        message.apiVersion = (_b = object.apiVersion) !== null && _b !== void 0 ? _b : "";
        message.buildTime = (_c = object.buildTime) !== null && _c !== void 0 ? _c : "";
        message.commit = (_d = object.commit) !== null && _d !== void 0 ? _d : "";
        message.buildNumber = (_e = object.buildNumber) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
//# sourceMappingURL=common.js.map